import { render, staticRenderFns } from "./CollectionConfig.vue?vue&type=template&id=7856a4fc"
import script from "./CollectionConfig.vue?vue&type=script&lang=js"
export * from "./CollectionConfig.vue?vue&type=script&lang=js"
import style0 from "./CollectionConfig.vue?vue&type=style&index=0&id=7856a4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports